import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { AppUserForDropdown } from '../../api/models';

export type TABLE_TYPE = Table<AppUserForDropdown>;

export const TABLE = 'appUserForDropdown';
const SCHEMA = 'id';

class AppUserForDropdownDatabase implements DataRepository<AppUserForDropdown> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<AppUserForDropdown | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: AppUserForDropdown, key: Key): Promise<AppUserForDropdown> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: AppUserForDropdown[]): Promise<AppUserForDropdown[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<AppUserForDropdown[]> {
    return this.db[TABLE].toArray();
  }
}

export const AppUserForDropdownDB = new AppUserForDropdownDatabase(db);
